import { Box, Skeleton, styled } from "@mui/material";

export function ExampleProjectsSkeleton() {
  const numItems = new Array(4).fill(1);

  return (
    <StyledBox>
      {numItems.map((_, i) => (
        <Skeleton key={i} height={150} width={200} />
      ))}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(4)};
  > div {
    display: flex;
    flex-direction: column;
    min-height: 80px;
    max-width: 250px;
    width: 100%;
  }
`;
